module.exports = __webpack_public_path__ + "static/media/william-hook.37922545.png";